import { captureCampaignAttribution } from "@/components/analytics/attribution";
import {
  MARKETING_CONSENT_EVENT,
  readMarketingConsent,
} from "@/components/analytics/consent";
import { useLocation } from "@tanstack/react-router";
import { useEffect } from "react";

export function AttributionTracker() {
  const searchStr = useLocation({ select: (location) => location.searchStr });

  useEffect(() => {
    // Re-run attribution capture after client-side navigation changes the URL.
    void searchStr;
    const captureWithConsent = () => {
      if (readMarketingConsent() === "granted") {
        captureCampaignAttribution();
      }
    };

    captureWithConsent();
    window.addEventListener(MARKETING_CONSENT_EVENT, captureWithConsent);

    return () => {
      window.removeEventListener(MARKETING_CONSENT_EVENT, captureWithConsent);
    };
  }, [searchStr]);

  return null;
}
